import {
  faDownload,
  faGear,
  faRotateRight,
  faUpRightFromSquare,
  faLayerGroup,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FC, useEffect, useMemo, useRef, useState } from "react";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { Circle, Group, Image, Layer, Rect, Stage, Text } from "react-konva";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import closeButton from "../../../../../assets/images/close-button.png";
import SkeletonComponent from "../../../../../shared/custom-spinner/skeleton.component";
import { dataUrlToFile } from "../../../../../shared/helpers/data-url-to-file";
import { safeAtob } from "../../../../../shared/helpers/enode-decode-string";
import { FloorShape } from "../../../../../shared/models/floorPlan";
import "./floorPlan.scss";

import gatewayFault from "./images/gateway-fault-filled.png";
import gatewayInitial from "./images/gateway-initial-filled.png";
import gatewayOffline from "./images/gateway-offline-filled.png";
import gatewayOnline from "./images/gateway-online-filled.png";

import photocellOnline from "./images/PhotocellSensorGreen.png";
import photocellOffline from "./images/PhotocellSensorGrey.png";
import photocellOff from "./images/PhotocellSensorRed.png";

import circleSelectedLight from "./images/circle-light-selected.png";

import { B2Form, B2Switch } from "@hdb/biome-2";
import Konva from "konva";
import { Spinner } from "react-bootstrap"; // or your preferred modal component
import { DynamicValuesEnum } from "src/core/enums/dynamic-values.enum";
import { floorplanColors } from "src/core/enums/floorplan-color-enums";
import { formatDateTime } from "src/shared/helpers/convert-time-format";
import { calculateAllDynamicValues } from "src/shared/helpers/dynamic-values.helper";
import {
  calculateImageDimensions,
  createPinchZoomHandlers,
  getZoomStepIn,
  getZoomStepOut,
  handleShapeMouseEnter,
  handleShapeMouseLeave,
  handleStageWheel as handleStageWheelHelper,
} from "src/shared/helpers/floorplan.helpers";
import { calculateLabelLayouts } from "src/shared/helpers/label-layout.helper";
import {
  exportStageToPDF,
  generatePDFFileName,
} from "src/shared/helpers/pdf-export.helper";
import { getLocationBlockByCode } from "src/store/slices/location-block.slice";
import exitFullScreen from "../../../../../assets/images/arrows-collapse.png";
import fullScreen from "../../../../../assets/images/arrows-fullscreen.png";
import zoomIn from "../../../../../assets/images/zoom-in.png";
import zoomOut from "../../../../../assets/images/zoom-out.png";
import {
  getLastDaylightReadingByAsset,
  getLastMotionReadingByAsset,
  getLastStatusReadingByAsset,
} from "../../../../../core/api/services/asset.service";
import useOutsideClick from "../hooks/useOutsideClick";
import { B2Divider } from "@hdb/biome-2";

interface FloorPlanComponentPropsType {
  imageFile: any;
  responseShapes: any;
  isLoadingFloorAssetsAndShapes: boolean;
  isLoadingFloorDetails: boolean;
  selectedSearchedAssetCodeForHighlighting: any;
  setSelectedSearchedAssetCodeForHighlighting: any;
  isProcessingImage: boolean;
}

const FloorPlanComponent: FC<FloorPlanComponentPropsType> = ({
  imageFile,
  responseShapes,
  isLoadingFloorAssetsAndShapes,
  isLoadingFloorDetails,
  selectedSearchedAssetCodeForHighlighting,
  setSelectedSearchedAssetCodeForHighlighting,
  isProcessingImage,
}: any) => {
  const stageRef: any = useRef();
  const pinchStateRef: any = useRef(null);
  const params = useParams();
  const blockCode: any = params.blockCode ? safeAtob(params.blockCode) : null;
  const floor = params?.floor;
  const dispatch = useDispatch();
  const [isLoadingMotionAndDaylightValue, setIsLoadingMotionAndDaylightValue] =
    useState(false);
  const [isLoadingStatusValue, setIsLoadingStatusValue] = useState(false);

  // Gateway
  const file1 = "image1.png";
  const gatewayFileFault: any = useMemo(
    () => dataUrlToFile(gatewayFault, file1),
    [],
  );

  const file2 = "image1.png";
  const gatewayFileInitial: any = useMemo(
    () => dataUrlToFile(gatewayInitial, file2),
    [],
  );

  const file3 = "image1.png";
  const gatewayFileOffline: any = useMemo(
    () => dataUrlToFile(gatewayOffline, file3),
    [],
  );

  const file4 = "image1.png";
  const gatewayFileOnline: any = useMemo(
    () => dataUrlToFile(gatewayOnline, file4),
    [],
  );

  const file5 = "image5.png";
  const photocellFileOnline: any = useMemo(
    () => dataUrlToFile(photocellOnline, file5),
    [],
  );

  const file6 = "image6.png";
  const photocellFileOffline: any = useMemo(
    () => dataUrlToFile(photocellOffline, file6),
    [],
  );

  const file7 = "image7.png";
  const photocellFileOff: any = useMemo(
    () => dataUrlToFile(photocellOff, file7),
    [],
  );

  const filename10 = "image10.png";
  const selectedFile: any = useMemo(
    () => dataUrlToFile(circleSelectedLight, filename10),
    [],
  );

  const [showLabels, setShowLabels] = useState(false);
  const [showAssets, setShowAssets] = useState(true);
  const [showLayerDropdown, setShowLayerDropdown] = useState(false);
  // Toggle to enable/disable label overlap avoidance
  const [preventLabelOverlap, setPreventLabelOverlap] = useState(false);

  // Export settings (DPI for high-resolution exports)
  const exportDPI = 600;

  const [globalSelectedShape, setGlobalSelectedShape] = useState(null as any);
  const [selectedWhileHovered, setSelectedWhileHovered] = useState(null as any);

  const [gatewayImageFileFault, setGatewayImageFileFault] =
    useState<any>(undefined);
  const [gatewayImageFileOffline, setGatewayImageFileOffline] =
    useState<any>(undefined);
  const [gatewayImageFileInitial, setGatewayImageFileInitial] =
    useState<any>(undefined);
  const [gatewayImageFileOnline, setGatewayImageFileOnline] =
    useState<any>(undefined);

  const [photocellImageFileOnline, setPhotocellImageFileOnline] =
    useState<any>(undefined);
  const [photocellImageFileOffline, setPhotocellImageFileOffline] =
    useState<any>(undefined);
  const [photocellImageFileOff, setPhotocellImageFileOff] =
    useState<any>(undefined);

  const [selectedImageFile, setSelectedImageFile] = useState<any>(undefined);

  const [hovered, setHovered] = useState(false);

  // const [shapes, setShapes] = useState<FloorShape[]>([]);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [newValueOnStageMove, setNewValueOnStageMove] = useState({
    x: 0,
    y: 0,
  });

  // Calculated values based on zoom level
  const [dynamicCircle, setDynamicCircle] = useState(DynamicValuesEnum.CIRCLE);
  const [circlePositionOffset, setCirclePositionOffset] = useState(0);

  // Label dynamics object containing all label-related properties
  const [labelDynamics, setLabelDynamics] = useState({
    fontSize: DynamicValuesEnum.FONT_SIZE,
    height: DynamicValuesEnum.LABEL_HEIGHT,
    yOffset: DynamicValuesEnum.LABEL_Y_OFFSET,
    padding: DynamicValuesEnum.LABEL_PADDING,
    textPadding: DynamicValuesEnum.TEXT_PADDING,
    strokeWidth: DynamicValuesEnum.STROKE_WIDTH,
    cornerRadius: DynamicValuesEnum.CORNER_RADIUS,
    shadowBlur: DynamicValuesEnum.SHADOW_BLUR,
    shadowColor: DynamicValuesEnum.SHADOW_COLOR,
    shadowOffset: DynamicValuesEnum.SHADOW_OFFSET,
  });

  const { width, height, assetScale } = useMemo(
    () => calculateImageDimensions(imageFile),
    [imageFile],
  );

  const scaledShapes = useMemo(() => {
    if (!responseShapes?.length) return [];

    return responseShapes.map((shape: FloorShape) => ({
      ...shape,
      x: (shape?.x ?? 0) * assetScale.x,
      y: (shape?.y ?? 0) * assetScale.y,
    }));
  }, [responseShapes, assetScale]);

  // Gateway dynamics object containing width, height and offset calculation
  const [dynamicGatewaySize, setDynamicGateway] = useState(
    DynamicValuesEnum.GATEWAY_SIZE,
  );
  const [dynamicGatewayOffset, setDynamicGatewayOffset] = useState(0);
  const [dynamicGatewayLabelOffset, setDynamicGatewayLabelOffset] = useState(
    DynamicValuesEnum.GATEWAY_LABEL_OFFSET,
  );
  const [dynamicPhotocellLabelOffset, setDynamicPhotocellLabelOffset] =
    useState(DynamicValuesEnum.PHOTOCELL_LABEL_OFFSET);

  // Pre-calculated, non-overlapping label layouts keyed by shape id
  const labelLayouts = useMemo(() => {
    return calculateLabelLayouts({
      showLabels,
      showAssets,
      shapes: scaledShapes,
      labelDynamics,
      preventLabelOverlap,
      dynamicCircle,
      // scale: imageScale,
    });
  }, [
    showLabels,
    showAssets,
    scaledShapes,
    labelDynamics.fontSize,
    labelDynamics.height,
    labelDynamics.padding,
    labelDynamics.yOffset,
    preventLabelOverlap,
    dynamicCircle,
    // imageScale,
  ]);

  const blockDetail = useSelector(
    (state: any) => state.locationBlock.locationBlockDetails,
  );
  const isLoadingLocationBlockDetails = useSelector(
    (state: any) => state.locationBlock.isLoadingLocationBlockDetails,
  );

  const handleStageDrag = (x: any, y: any) => {
    setNewValueOnStageMove({ x, y });

    if (tooltip?.visible && globalSelectedShape) {
      const baseX = globalSelectedShape?.x ?? 0;
      const baseY = globalSelectedShape?.y ?? 0;
      const adjustedX = (baseX + x) * zoomLevel;
      const adjustedY = (baseY + y) * zoomLevel;

      setTooltip({
        ...tooltip,
        x: adjustedX,
        y: adjustedY - 10,
      });
    }
  };

  const [containerDimensions, setContainerDimensions] = useState({
    width: 942,
    height: 530,
  });

  const [tooltip, setTooltip] = useState({
    visible: false,
    content: "",
    selectedItemId: null,
    x: 0,
    y: 0,
  });

  const [hoverState, setHoverState] = useState({
    visible: false,
    x: 0,
    y: 0,
  });

  // gateway
  useEffect(() => {
    const imageUrl = URL.createObjectURL(gatewayFileFault);
    const imageElement = new window.Image();
    imageElement.src = imageUrl;

    setGatewayImageFileFault(imageElement);
  }, [gatewayFileFault]);

  useEffect(() => {
    const imageUrl = URL.createObjectURL(gatewayFileInitial);
    const imageElement = new window.Image();
    imageElement.src = imageUrl;

    setGatewayImageFileInitial(imageElement);
  }, [gatewayFileInitial]);

  useEffect(() => {
    const imageUrl = URL.createObjectURL(gatewayFileOffline);
    const imageElement = new window.Image();
    imageElement.src = imageUrl;

    setGatewayImageFileOffline(imageElement);
  }, [gatewayFileOffline]);

  useEffect(() => {
    const imageUrl = URL.createObjectURL(gatewayFileOnline);
    const imageElement = new window.Image();
    imageElement.src = imageUrl;

    setGatewayImageFileOnline(imageElement);
  }, [gatewayFileOnline]);

  useEffect(() => {
    const imageUrl = URL.createObjectURL(photocellFileOnline);
    const imageElement = new window.Image();
    imageElement.src = imageUrl;

    setPhotocellImageFileOnline(imageElement);
  }, [photocellFileOnline]);

  useEffect(() => {
    const imageUrl = URL.createObjectURL(photocellFileOffline);
    const imageElement = new window.Image();
    imageElement.src = imageUrl;

    setPhotocellImageFileOffline(imageElement);
  }, [photocellFileOffline]);

  useEffect(() => {
    const imageUrl = URL.createObjectURL(photocellFileOff);
    const imageElement = new window.Image();
    imageElement.src = imageUrl;

    setPhotocellImageFileOff(imageElement);
  }, [photocellFileOff]);

  useEffect(() => {
    const imageUrl = URL.createObjectURL(selectedFile);
    const imageElement = new window.Image();
    imageElement.src = imageUrl;

    setSelectedImageFile(imageElement);
  }, [selectedFile]);

  useEffect(() => {
    return () => {
      setSelectedSearchedAssetCodeForHighlighting(""); // Reset the state
    };
  }, []);

  useEffect(() => {
    if (!selectedSearchedAssetCodeForHighlighting) {
      setSelectedSearchedAssetCodeForHighlighting("");
    }
  }, [isLoadingFloorAssetsAndShapes]);

  const loaderRef = useRef<Konva.Group>(null);

  // Hover timer to show hover tooltip only after a short delay
  const hoverTimeoutRef = useRef<number | null>(null);
  const HOVER_DELAY = 500; // milliseconds

  // Cleanup hover timer on unmount
  useEffect(() => {
    return () => {
      if (hoverTimeoutRef.current) {
        window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = null;
      }
    };
  }, []);

  //// dynamic values for zoom level start //////

  // Update calculated values when zoom level changes

  useEffect(() => {
    // Calculate all dynamic values using the helper function
    const dynamicValues = calculateAllDynamicValues(zoomLevel);

    // Update all state values with calculated values
    setDynamicCircle(dynamicValues.circle);
    setCirclePositionOffset(dynamicValues.circlePositionOffset);
    setLabelDynamics(dynamicValues.labelDynamics);
    setDynamicGateway(dynamicValues.gateway.size);
    setDynamicGatewayOffset(dynamicValues.gateway.offset);
    setDynamicGatewayLabelOffset(dynamicValues.gateway.labelOffset);
    setDynamicPhotocellLabelOffset(dynamicValues.photocell.labelOffset);
    // console.log("Gateway Label Offset:", dynamicValues.gateway.labelOffset);
  }, [zoomLevel]);

  const handleZoomIn = () => {
    setZoomLevel(
      Math.min(
        DynamicValuesEnum.MAX_ZOOM,
        zoomLevel + getZoomStepIn(zoomLevel),
      ),
    );
    setHoverState({ ...hoverState, visible: false });
    setTooltip({ ...tooltip, visible: false });
    setGlobalSelectedShape(null);
    setSelectedWhileHovered(null);
  };

  const handleZoomOut = () => {
    setZoomLevel(Math.max(0.5, zoomLevel - getZoomStepOut(zoomLevel)));
    setTooltip({ ...tooltip, visible: false });
    setHoverState({ ...hoverState, visible: false });
    setGlobalSelectedShape(null);
    setSelectedWhileHovered(null);
  };

  // // Wheel zoom while hovering the stage — delegating to shared helper
  const handleStageWheel = (e: any) => {
    handleStageWheelHelper({
      e,
      stageRef,
      zoomLevel,
      setZoomLevel,
      newValueOnStageMove,
      setNewValueOnStageMove,
      setTooltip,
      tooltip,
      setHoverState,
      hoverState,
      setGlobalSelectedShape,
      setSelectedWhileHovered,
      dynamicValuesEnumMaxZoom: DynamicValuesEnum.MAX_ZOOM,
    });
  };

  // Touch handlers for smooth pinch-to-zoom / two-finger pan on mobile
  const { handleTouchStart, handleTouchMove, handleTouchEnd } =
    createPinchZoomHandlers(
      {
        stageRef,
        zoomLevel,
        setZoomLevel,
        dynamicValuesEnumMaxZoom: DynamicValuesEnum.MAX_ZOOM,
        dynamicValuesEnumMinZoom: 0.5,
        setNewValueOnStageMove,
      },
      pinchStateRef,
    );


  // Reset zoom and re-center the stage layer to top-left
  const handleResetZoom = () => {
    setZoomLevel(1);
    setNewValueOnStageMove({ x: 0, y: 0 });

    const stage: any = stageRef.current;
    if (stage) {
      try {
        const layers = stage.getLayers ? stage.getLayers() : [];
        const layer = layers && layers.length ? layers[0] : null;
        if (layer) {
          layer.position({ x: 0, y: 0 });
          layer.batchDraw ? layer.batchDraw() : layer.draw();
        }
      } catch (err) {
        // fail silently if Konva refs not ready
        // eslint-disable-next-line no-console
        console.warn("Could not reset layer position:", err);
      }
    }

    setTooltip({ ...tooltip, visible: false });
    setHoverState({ ...hoverState, visible: false });
    setGlobalSelectedShape(null);
    setSelectedWhileHovered(null);
  };

  const handleOnAssetClick = async (id: any, e?: any) => {
    const selectedShape = scaledShapes?.find(
      (shape: FloorShape) => shape?.id === id,
    );
    if (!selectedShape) {
      setIsLoadingMotionAndDaylightValue(false);
      return;
    }

    // "1" and "44" for photocell sensor, "3" for gateway
    const isImageBasedAsset =
      selectedShape?.parentAssetTypeId?.toLowerCase() === "3" ||
      selectedShape?.parentAssetTypeId?.toLowerCase() === "1" || selectedShape?.parentAssetTypeId?.toLowerCase() === "44";

    const offset = isImageBasedAsset
      ? dynamicGatewayOffset
      : circlePositionOffset;

    const baseX = selectedShape?.x ?? 0;
    const baseY = selectedShape?.y ?? 0;

    const adjustedX =
      (baseX + newValueOnStageMove?.x + offset) * zoomLevel;
    const adjustedY =
      (baseY + newValueOnStageMove?.y + offset) * zoomLevel;

    setTooltip({
      visible: true,
      content: `Asset ID: ${selectedShape?.assetCode}\nLocation: ${selectedShape?.floorLocation
        }\nType: ${selectedShape?.assetType}\nLast Online man: ${selectedShape?.lastOnline ? selectedShape?.lastOnline : "-"
        }`,
      selectedItemId: id,
      x: handle.active && e ? e?.evt?.layerX - 18 : adjustedX,
      y: handle.active && e ? e?.evt?.layerY - 20 : adjustedY,
    });

    setGlobalSelectedShape(selectedShape);

    /*     dispatch(
      sendGetCommandToDms({
        assetCode: selectedShape.assetCode,
        module: Number(AssetCommandEnums.getLightIntensity),
      })
    ); */

    // Start all three APIs together
    setIsLoadingStatusValue(true);

    const motionPromise = getLastMotionReadingByAsset(
      selectedShape.assetCode,
      null,
    );
    const daylightPromise = getLastDaylightReadingByAsset(
      selectedShape.assetCode,
      null,
    );
    const statusPromise = getLastStatusReadingByAsset(
      selectedShape.assetCode,
      null,
    );

    // Update motion/daylight as they finish
    Promise.all([motionPromise, daylightPromise])
      .then(([motionData, daylightData]) => {
        setGlobalSelectedShape((prev: any) => ({
          ...prev,
          motionCount: motionData?.data?.motionReading ?? prev?.motionCount,
          daylight: daylightData?.data?.daylightReading ?? prev?.daylight,
        }));
        setIsLoadingMotionAndDaylightValue(false);
      })
      .catch((error) => {
        console.error("Error fetching motion/daylight data:", error);
        setIsLoadingMotionAndDaylightValue(false);
      });

    // Update status separately as it finishes
    statusPromise
      .then((statusData) => {
        setGlobalSelectedShape((prev: any) => ({
          ...prev,
          lightStatus: statusData?.data?.lightStatus ?? prev?.lightStatus,
          lightIntensity:
            statusData?.data?.lightIntensity ?? prev?.lightIntensity,
        }));
        setIsLoadingStatusValue(false);
      })
      .catch((error) => {
        console.error("Error fetching light status data:", error);
        setIsLoadingStatusValue(false);
      });
  };

  const dimensions = () => {
    const totalWidthElement = document.getElementById("totalWidth");

    setContainerDimensions({
      height: 530,
      width: totalWidthElement?.offsetWidth
        ? totalWidthElement?.offsetWidth - 100
        : 942,
    });
  };

  useEffect(() => {
    dimensions();
  }, []);

  const handle = useFullScreenHandle();

  const handleFullScreenClose = (currentState: boolean) => {
    if (!currentState) {
      setZoomLevel(1);
      dimensions();
      setGlobalSelectedShape(null);
      setSelectedWhileHovered(null);
    }
  };

  const handleAssetRedirectionClick = () => {
    const newTab = window.open(
      `/asset/${btoa(globalSelectedShape?.assetCode)}`,
      "_blank",
    );
    newTab?.focus();
  };

  const handleAssetRedirectionToConfiguration = () => {
    const newTab = window.open(
      `/asset/${btoa(globalSelectedShape?.assetCode)}/configuration/general-configuration`,
      "_blank",
    );
    newTab?.focus();
  };

  const [isHoveredTooltipElement, setIsHoveredTooltipElement] = useState(false);

  const closeToolTip = () => {
    if (!isHoveredTooltipElement && !hovered) {
      setTooltip({ ...tooltip, visible: false });
      setGlobalSelectedShape(null);
    }
  };

  const { ref: toolTipRef, isClickedOutside: isOutside } =
    useOutsideClick(closeToolTip);

  const handleExportPDF = async (
    includeLabels: boolean,
    includeAssets: boolean,
  ) => {
    const stage = stageRef.current;
    if (!stage) return;

    try {
      const fileName = generatePDFFileName(blockDetail, floor || "Unknown");

      await exportStageToPDF({
        stage,
        includeLabels,
        includeAssets,
        exportDPI,
        fileName,
        shapes: scaledShapes, // Pass shapes data for status-based colors
        type: "light-status",
      });
    } catch (error) {
      console.error("Error exporting PDF:", error);
      // You can add user notification here if needed
    }
  };

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (
        !target.closest(".layer-dropdown") &&
        !target.closest(".fa-layer-group")
      ) {
        setShowLayerDropdown(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  // Extract nested ternary for light status/intensity into separate variables
  const lightStatusText = useMemo(() => {
    const intensity =
      globalSelectedShape?.lightIntensity == null
        ? ""
        : `(${globalSelectedShape?.lightIntensity || 0}%)`;
    const status =
      globalSelectedShape?.lightStatus == null
        ? "N/A"
        : `${globalSelectedShape?.lightStatus} ${intensity}`;
    return status;
  }, [globalSelectedShape?.lightStatus, globalSelectedShape?.lightIntensity]);

  return (
    <div className="w-100" id="totalWidth">
      <SkeletonComponent
        wrapperHeight="570px"
        skeletonHeight="570px"
        isLoading={isLoadingFloorDetails || isProcessingImage}
      >
        {imageFile &&
          gatewayImageFileFault &&
          gatewayImageFileOffline &&
          gatewayImageFileInitial &&
          gatewayImageFileOnline &&
          photocellImageFileOnline &&
          photocellImageFileOffline &&
          photocellImageFileOff &&
          selectedImageFile ? (
          <FullScreen
            handle={handle}
            onChange={(state: boolean) => {
              handleFullScreenClose(state);
            }}
          >
            <div className="mt-3 position-relative w-100">
              <div
                className="flex justify-end w-100"
                style={{
                  marginTop: handle?.active
                    ? "5rem"
                    : "1rem",
                  paddingRight: "1rem",
                  position: "absolute"
                }}
              >
                <div className="d-flex flex-col align-items-end">
                  <div>
                    <button
                      className={"cursor-pointer me-2 mb-3"}
                      style={{
                        width: "25px",
                        padding: 0,
                        border: "none",
                        backgroundColor: "transparent",
                        display: "flex",
                      }}
                      type="button"
                      onClick={handleZoomIn}
                      title="Zoom In"
                      aria-label="Zoom In"
                    >
                      <img
                        src={zoomIn}
                        alt=""
                        aria-hidden="true"
                        style={{ width: "100%", height: "100%" }}
                      />
                    </button>
                  </div>
                  {/* {zoomLevel.toFixed(2)}  */}
                  <div>
                    <button
                      className={"cursor-pointer me-2 mb-2"}
                      style={{
                        width: "25px",
                        padding: 0,
                        border: "none",
                        backgroundColor: "transparent",
                        display: "flex",
                      }}
                      type="button"
                      onClick={handleZoomOut}
                      title="Zoom Out"
                      aria-label="Zoom Out"
                    >
                      <img
                        src={zoomOut}
                        alt=""
                        aria-hidden="true"
                        style={{ width: "100%", height: "100%" }}
                      />
                    </button>
                  </div>
                  {zoomLevel !== 1 && (
                    <div>
                      <button
                        className="btn pb-0 "
                        style={{ marginRight: "0.2rem", padding: "0.5rem" }}
                        onClick={handleResetZoom}
                        title="Reset Zoom"
                      >
                        <FontAwesomeIcon
                          icon={faRotateRight}
                          style={{ fontSize: "1.35rem" }}
                        />
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <Stage
                width={containerDimensions.width}
                height={containerDimensions.height}
                scaleX={zoomLevel}
                scaleY={zoomLevel}
                ref={stageRef}
                onWheel={handleStageWheel}
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
                className={`my-3 ${handle.active ? "" : "stage-wrapper"} `}
                onClick={() => setSelectedSearchedAssetCodeForHighlighting("")}
              >
                <Layer
                  y={15}
                  draggable
                  isLayer={true}
                  onDragEnd={(e) => {
                    const target = e.target;
                    if (target.attrs.isLayer) {
                      handleStageDrag(e.target.x(), e.target.y());
                    }
                  }}
                >
                  {imageFile && containerDimensions?.height > 0 && (
                    <Image
                      name="floor-image"
                      image={imageFile}
                      width={width}
                      height={height}
                    />
                  )}

                  {/* Loader to show the loading state for asset being loaded on the stage */}
                  {isLoadingFloorAssetsAndShapes ? (
                    <Group
                      ref={loaderRef}
                      listening={false}
                      x={containerDimensions.width / 2}
                      y={containerDimensions.height / 2}
                    >
                      <Rect
                        width={150}
                        height={80}
                        offsetX={75}
                        offsetY={35}
                        fill="#ffffff"
                        stroke="#d0d0d0"
                        cornerRadius={8}
                        shadowColor="rgba(0,0,0,0.18)"
                        shadowBlur={8}
                        shadowOffsetY={4}
                        shadowOpacity={0.4}
                      />

                      {/* Spinner */}
                      <Circle
                        name="loader-circle"
                        radius={18}
                        stroke="#1976D2"
                        strokeWidth={4}
                        dash={[12, 8]}
                        y={-5}
                      />

                      {/* Text */}
                      <Text
                        text="Loading Assets..."
                        fontSize={13}
                        fill="#333"
                        fontStyle="bold"
                        y={22}
                        align="center"
                        offsetX={50}
                      />
                    </Group>
                  ) : (
                    showAssets &&
                    scaledShapes?.map((shape: FloorShape) => {
                      // "1" and "44" for photocell sensor, "3" for gateway
                      const parentAssetTypeId = shape?.parentAssetTypeId?.toLowerCase();
                      const isGateway = parentAssetTypeId === "3";
                      const isPhotocell = parentAssetTypeId === "1" || parentAssetTypeId === "44";

                      // Select the appropriate asset image based on the status
                      const isOnline =
                        shape?.status === "On" || shape?.status === "Online";
                      const isOffline =
                        shape?.status === "N/A" ||
                        shape?.status === "Offline" ||
                        shape?.status === "Off";
                      let assetImage = photocellImageFileOff;

                      if (shape?.highlightedAsset) {
                        assetImage = selectedImageFile;
                      } else if (isGateway) {
                        if (isOnline) {
                          assetImage = gatewayImageFileOnline;
                        } else if (isOffline) {
                          assetImage = gatewayImageFileInitial;
                        } else {
                          assetImage = gatewayImageFileFault;
                        }
                      } else if (isOnline) {
                        assetImage = photocellImageFileOnline;
                      } else if (isOffline) {
                        assetImage = photocellImageFileOffline;
                      }
                      // Asset Image Selection End

                      // Measure Y axis offset
                      let yOffsetTxt = 0;

                      if (isGateway) {
                        yOffsetTxt = dynamicGatewayLabelOffset;
                      } else if (isPhotocell) {
                        yOffsetTxt = dynamicPhotocellLabelOffset;
                      }
                      // Measure Y axis offset End

                      // Select the appropriate asset fill based on the status
                      let assetFill = floorplanColors.fault;

                      if (shape?.highlightedAsset) {
                        assetFill = floorplanColors.selected;
                      } else if (isOnline) {
                        assetFill = floorplanColors.lightOn;
                      } else if (isOffline) {
                        assetFill = floorplanColors.lightOff;
                      }
                      // Select the appropriate asset fill based on the status End

                      return (
                        <React.Fragment key={shape.id}>
                          {isGateway || isPhotocell ? (
                            <>
                              <Image
                                name={
                                  isGateway
                                    ? "gateway-image"
                                    : "photocell-image"
                                }
                                x={
                                  shape.x +
                                  dynamicGatewayOffset
                                }
                                y={
                                  shape.y +
                                  dynamicGatewayOffset
                                }
                                image={assetImage}
                                width={dynamicGatewaySize}
                                height={dynamicGatewaySize}
                                onClick={(e: any) => {
                                  setIsLoadingMotionAndDaylightValue(true);
                                  handleOnAssetClick(shape?.id, e);
                                }}
                                onTap={(e: any) => {
                                  setIsLoadingMotionAndDaylightValue(true);
                                  handleOnAssetClick(shape?.id, e);
                                }}
                                onMouseEnter={(e: any) =>
                                  handleShapeMouseEnter({
                                    e,
                                    shape,
                                    shapes: scaledShapes,
                                    hoverTimeoutRef,
                                    HOVER_DELAY,
                                    setHovered,
                                    setSelectedWhileHovered,
                                    setHoverState,
                                    // newValueOnStageMove,
                                    // zoomLevel,
                                    // dynamicGatewayOffset,
                                    // circlePositionOffset,
                                  })
                                }
                                onMouseLeave={(e: any) =>
                                  handleShapeMouseLeave({
                                    e,
                                    hoverTimeoutRef,
                                    setHovered,
                                    setHoverState,
                                    setSelectedWhileHovered,
                                  })
                                }
                              />
                              {/* 🏷️ Show gateway sensor name as Konva Text (non-overlapping) */}
                              {showLabels &&
                                shape?.labelDisplayName &&
                                (() => {
                                  const layout = labelLayouts.get(shape.id);
                                  if (!layout) return null;
                                  return (
                                    <Group
                                      x={layout.x}
                                      y={layout.y + yOffsetTxt}
                                      name="sensor-label"
                                      listening={false}
                                    >
                                      <Rect
                                        width={layout.w}
                                        height={layout.h}
                                        fill="#fff"
                                        stroke="#bdbdbd"
                                        strokeWidth={labelDynamics.strokeWidth}
                                        cornerRadius={
                                          labelDynamics.cornerRadius
                                        }
                                        shadowColor={`rgba(0,0,0,${labelDynamics.shadowColor})`}
                                        shadowBlur={labelDynamics.shadowBlur}
                                        shadowOffset={{
                                          x: labelDynamics.shadowOffset,
                                          y: labelDynamics.shadowOffset,
                                        }}
                                      />
                                      <Text
                                        text={shape?.labelDisplayName}
                                        fontSize={labelDynamics.fontSize}
                                        fill="#333"
                                        fontStyle="bold"
                                        padding={labelDynamics.textPadding}
                                        align="left"
                                      />
                                    </Group>
                                  );
                                })()}
                            </>
                          ) : (
                            // for sensors
                            <>
                              <Circle
                                name="asset-circle"
                                x={
                                  shape?.x +
                                  circlePositionOffset +
                                  dynamicCircle / 2
                                }
                                y={
                                  shape?.y +
                                  circlePositionOffset +
                                  dynamicCircle / 2
                                }
                                radius={dynamicCircle / 2}
                                fill={assetFill}
                                stroke={floorplanColors.border}
                                strokeWidth={Math.max(0.1, 0.5 / zoomLevel)}
                                onClick={(e: any) => {
                                  setIsLoadingMotionAndDaylightValue(true);
                                  handleOnAssetClick(shape?.id, e);
                                }}
                                onTap={(e: any) => {
                                  setIsLoadingMotionAndDaylightValue(true);
                                  handleOnAssetClick(shape?.id, e);
                                }}
                                onMouseEnter={(e: any) =>
                                  handleShapeMouseEnter({
                                    e,
                                    shape,
                                    shapes: scaledShapes,
                                    hoverTimeoutRef,
                                    HOVER_DELAY,
                                    setHovered,
                                    setSelectedWhileHovered,
                                    setHoverState,
                                    // newValueOnStageMove,
                                    // zoomLevel,
                                    // dynamicGatewayOffset,
                                    // circlePositionOffset,
                                  })
                                }
                                onMouseLeave={(e: any) =>
                                  handleShapeMouseLeave({
                                    e,
                                    hoverTimeoutRef,
                                    setHovered,
                                    setHoverState,
                                    setSelectedWhileHovered,
                                  })
                                }
                              />
                              {/* 🏷️ Show asset sensor name as Konva Text (non-overlapping) */}
                              {showLabels &&
                                shape?.labelDisplayName &&
                                (() => {
                                  const layout = labelLayouts.get(shape.id);
                                  if (!layout) return null;
                                  return (
                                    <Group
                                      x={layout.x}
                                      y={layout.y}
                                      name="sensor-label"
                                      listening={false}
                                    >
                                      <Rect
                                        width={layout.w}
                                        height={layout.h} // labelDynamics.height or layout.h
                                        fill="#fff"
                                        stroke="#bdbdbd"
                                        strokeWidth={labelDynamics.strokeWidth}
                                        cornerRadius={
                                          labelDynamics.cornerRadius
                                        }
                                        shadowColor={`rgba(0,0,0,${labelDynamics.shadowColor})`}
                                        shadowBlur={labelDynamics.shadowBlur}
                                        shadowOffset={{
                                          x: labelDynamics.shadowOffset,
                                          y: labelDynamics.shadowOffset,
                                        }}
                                      />
                                      <Text
                                        text={shape?.labelDisplayName}
                                        fontSize={labelDynamics.fontSize}
                                        fill="#333"
                                        fontStyle="bold"
                                        padding={labelDynamics.textPadding}
                                        align="center"
                                      />
                                    </Group>
                                  );
                                })()}
                            </>
                          )}
                        </React.Fragment>
                      );
                    })
                  )}
                </Layer>
              </Stage>

              {/* Asset Details Modal */}
              {tooltip?.visible &&
                globalSelectedShape &&
                scaledShapes?.find(
                  (shape: FloorShape) => shape.id === tooltip.selectedItemId,
                ) && (
                  <div
                    ref={toolTipRef}
                    onMouseEnter={() => setIsHoveredTooltipElement(true)}
                    onMouseLeave={() => setIsHoveredTooltipElement(false)}
                    style={{
                      position: "absolute",
                      top: tooltip.y - 215,
                      left: tooltip.x - 157,
                      zIndex: 9999,
                      width: "400px",
                    }}
                  >
                    <div
                      className="floortooltip"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        height:
                          globalSelectedShape?.assetTypeId != 3
                            ? "220px"
                            : "200px",
                        width: "max-content",
                        zIndex: "999",
                        position: "relative",
                        borderRadius: "5px",
                        backgroundColor: "white",
                        boxShadow:
                          "0 -3px 3px -3px #e0e0e0, 3px 0px 3px -3px #d1d1d1, 5px 5px 3px -5px #e5e5e5",
                        padding: " 0.5rem 1rem",
                        lineHeight: "25px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <div className="d-flex mb-2">
                          <div className="tooltip-fs">Asset ID: </div>
                          <div
                            style={{ color: "#1976D2" }}
                            className="ms-2 tooltip-fs cursor-pointer"
                            onClick={handleAssetRedirectionClick}
                          >
                            {globalSelectedShape?.assetCode}
                            <FontAwesomeIcon
                              icon={faUpRightFromSquare}
                              className="fs-6 ms-2"
                              title={"Go to Asset Details"}
                            />
                          </div>
                          <FontAwesomeIcon
                            className="cursor-pointer fs-6 ms-2"
                            icon={faGear}
                            onClick={handleAssetRedirectionToConfiguration}
                            title={"Go to Asset Configuration"}
                            style={{ marginTop: "3.5px", color: "#1976D2" }}
                          />
                        </div>
                        <B2Divider />
                        <div className="d-flex tooltip-fs mt-2">
                          <div className="tooltip-fs">Display Name: </div>
                          <div className="ms-2 tooltip-fs">
                            {globalSelectedShape?.sensorDisplayName}{" "}
                          </div>
                        </div>
                        <div className="d-flex tooltip-fs">
                          <div className="tooltip-fs">Location: </div>
                          <div className="ms-2 tooltip-fs">
                            {globalSelectedShape?.displayLocationName}{" "}
                          </div>
                        </div>
                        <div className="d-flex tooltip-fs">
                          <div className="tooltip-fs">Light Type: </div>
                          <div className="ms-2 tooltip-fs">
                            {globalSelectedShape?.lightType}{" "}
                          </div>
                        </div>

                        <div className="d-flex tooltip-fs">
                          <div className="tooltip-fs">Last Heartbeat: </div>
                          <div className="ms-2 tooltip-fs">
                            {globalSelectedShape?.lastOnline
                              ? formatDateTime(globalSelectedShape?.lastOnline)
                              : "-"}
                          </div>
                        </div>

                        {globalSelectedShape?.assetTypeId != 3 ? (
                          <div className="d-flex tooltip-fs">
                            <div className="tooltip-fs">Motion Count: </div>
                            <div className="ms-2 tooltip-fs">
                              {isLoadingMotionAndDaylightValue ? (
                                <Spinner
                                  animation="border"
                                  variant="primary"
                                  size="sm"
                                  className="ms-4"
                                />
                              ) : (
                                <>
                                  {globalSelectedShape?.motionCount ?? "N/A"}
                                </>
                              )}
                            </div>
                          </div>
                        ) : null}

                        <div className="d-flex tooltip-fs">
                          <div className="tooltip-fs">Daylight: </div>
                          <div className="ms-2 tooltip-fs">
                            {isLoadingMotionAndDaylightValue ? (
                              <Spinner
                                animation="border"
                                variant="primary"
                                size="sm"
                                className="ms-4"
                              />
                            ) : (
                              <>
                                {globalSelectedShape?.daylight == null
                                  ? "-"
                                  : globalSelectedShape?.daylight + " Lux" || 0}
                              </>
                            )}
                          </div>
                        </div>

                        <div className="d-flex tooltip-fs">
                          <div className="tooltip-fs">Light Status: </div>
                          <div className="ms-2 tooltip-fs">
                            {isLoadingStatusValue ? (
                              <Spinner
                                animation="border"
                                variant="primary"
                                size="sm"
                                className="ms-4"
                              />
                            ) : (
                              <>{lightStatusText}</>
                            )}
                          </div>
                        </div>

                      </div>
                      <div style={{ width: "24px", position: "relative" }}>
                        <button
                          type="button"
                          style={{
                            position: "absolute",
                            top: -8,
                            right: -8,
                            cursor: "pointer",
                            fontSize: "22px",
                            color: "red",
                            padding: 0,
                            border: "none",
                            backgroundColor: "transparent",
                          }}
                          onClick={() => {
                            setGlobalSelectedShape(null);
                            setTooltip({ ...tooltip, visible: false });
                          }}
                          title="Close"
                          aria-label="Close"
                        >
                          <img
                            width={"24px"}
                            src={closeButton}
                            alt="close Button"
                          />
                        </button>
                      </div>
                    </div>
                    <div className="floorTooltipArrawContainer"></div>
                  </div>
                )}

              {/* Right Bottom icons */}
              <div
                className="flex justify-end w-100"
                style={{
                  marginTop: handle?.active
                    ? "-24rem"
                    : "-10rem",
                  paddingRight: "1rem",
                }}
              >
                <div className="d-flex flex-col align-items-end">
                  <div className="position-relative">
                    <FontAwesomeIcon
                      icon={faLayerGroup}
                      className="cursor-pointer me-2 mb-3"
                      style={{
                        height: "25px",
                        width: "25px",
                        paddingRight: "1px",
                      }}
                      title="Layer Settings"
                      onClick={() => setShowLayerDropdown(!showLayerDropdown)}
                    />

                    {showLayerDropdown && (
                      <div
                        className="layer-dropdown shadow-lg"
                        style={{
                          position: "absolute",
                          top: "2rem",
                          right: 0,
                          backgroundColor: "white",
                          borderRadius: "8px",
                          padding: "0.75rem 1rem",
                          width: "220px",
                          zIndex: 9999,
                        }}
                      >
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <span className="fw-semibold">Show Assets</span>
                          <B2Form.Group>
                            <B2Switch
                              type="switch"
                              name="showAssets"
                              onChange={(e: any) => {
                                setShowAssets(e.target.checked);
                                if (!e.target.checked) {
                                  setShowLabels(false);
                                }
                              }}
                              checked={showAssets}
                              value={showAssets}
                            />
                          </B2Form.Group>
                        </div>

                        <div className="d-flex justify-content-between align-items-center">
                          <span className="fw-semibold">Show Labels</span>
                          <B2Form.Group>
                            <B2Switch
                              type="switch"
                              name="showLabels"
                              onChange={(e: any) =>
                                setShowLabels(e.target.checked)
                              }
                              checked={showLabels}
                              value={showLabels}
                              disabled={!showAssets}
                            />
                          </B2Form.Group>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mt-2">
                          <span className="fw-semibold">Prevent Overlap</span>
                          <B2Form.Group>
                            <B2Switch
                              type="switch"
                              name="preventLabelOverlap"
                              onChange={(e: any) =>
                                setPreventLabelOverlap(e.target.checked)
                              }
                              checked={preventLabelOverlap}
                              value={preventLabelOverlap}
                              disabled={!showAssets || !showLabels}
                            />
                          </B2Form.Group>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="mb-3">
                    {isLoadingLocationBlockDetails && (
                      <Spinner
                        animation="border"
                        variant="primary"
                        size="sm"
                        className="me-2 mb-2"
                      />
                    )}
                    <FontAwesomeIcon
                      icon={faDownload}
                      className="cursor-pointer"
                      style={{
                        marginRight: "10px",
                        marginBottom: "6px",
                        height: "22px",
                        width: "22px",
                      }}
                      title="Export As PDF"
                      onClick={() => {
                        dispatch(getLocationBlockByCode({ blockCode })).then(
                          () => {
                            handleExportPDF(showLabels, showAssets);
                          },
                        );
                      }}
                    />
                  </div>

                  <div className="mt-1">
                    {handle?.active ? (
                      <button
                        type="button"
                        onClick={() => handle.exit()}
                        title="Exit Full Screen"
                        aria-label="Exit Full Screen"
                        className="cursor-pointer"
                        style={{
                          marginRight: "10px",
                          marginBottom: "16px",
                          height: "22px",
                          width: "22px",
                          padding: 0,
                          border: "none",
                          background: "transparent",
                          display: "flex",
                        }}
                      >
                        <img
                          src={exitFullScreen}
                          alt=""
                          aria-hidden="true"
                          style={{ height: "100%", width: "100%" }}
                        />
                      </button>
                    ) : (
                      <button
                        type="button"
                        onClick={() => {
                          handle.enter();
                          setZoomLevel(1.5);
                          setContainerDimensions({
                            height: window.innerHeight + 100,
                            width: window.innerWidth - 100,
                          });
                          setGlobalSelectedShape(null);
                        }}
                        title="View in Full Screen"
                        aria-label="View in Full Screen"
                        className="cursor-pointer"
                        style={{
                          marginRight: "10px",
                          marginBottom: "16px",
                          height: "22px",
                          width: "22px",
                          padding: 0,
                          border: "none",
                          background: "transparent",
                          display: "flex",
                        }}
                      >
                        <img
                          src={fullScreen}
                          alt=""
                          aria-hidden="true"
                          style={{ height: "100%", width: "100%" }}
                        />
                      </button>
                    )}
                  </div>
                </div>
              </div>

              {/* Mouse hover effect on the assets */}
              {hovered && hoverState?.visible && selectedWhileHovered && (
                <div>
                  <div
                    className="hovered-tooltip-container"
                    style={{
                      position: "absolute",
                      top: hoverState.y - 20,
                      left: hoverState.x - 100,
                      maxWidth: `${selectedWhileHovered?.sensorDisplayName?.length * 2.8
                        }rem`,
                    }}
                  >
                    <div className="d-flex hovered-tooltip-text">
                      <div className="hovered-tooltip-text">Display Name: </div>
                      <div className="ms-2 hovered-tooltip-text">
                        {selectedWhileHovered?.sensorDisplayName}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </FullScreen>
        ) : (
          <div className="no-preview-container">
            <h5>No Floor Plan to Preview</h5>
          </div>
        )}
      </SkeletonComponent>
    </div>
  );
};

export default FloorPlanComponent;
